import React, { useEffect } from 'react'

import { RESULTS_CONTAINER_ID, trackedIdentifier } from './useEmployerMatching'

// Double the Donation's matching-gift plugin, required for partner certification.
// Tailwind twin: donate_v7/EmployerMatchingResults.jsx.

const EmployerMatchingResults = ({ employerMatching, donation, donationsPath }) => {
  const { enabled, failed, loaded } = employerMatching

  // The container only renders once loaded, so it's committed by now.
  useEffect(() => {
    if (!enabled || failed || !loaded) return

    const identifier = trackedIdentifier(donation)
    employerMatching.loadResults(identifier,
      identifier && donation.token ? `${donationsPath}/${donation.token}` : null)
  }, [ loaded ])

  if (!enabled || failed || !loaded) return null

  return (
    // Separate wrapper: the plugin replaces the container's contents.
    <div className="employer-matching-results">
      <div id={RESULTS_CONTAINER_ID}></div>
    </div>
  )
}

export default EmployerMatchingResults
